import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AccesoState } from './acceso.reducers';

export const accesoState = createFeatureSelector<AccesoState>("acceso");


export const accesoSidebarCollapsed = createSelector(
	accesoState,
	state => state.sidebarCollapsed
)

export const aplicacionesFavsCollapsed = createSelector(
	accesoState,
	state => state.aplicacionesFavsCollapsed
)

export const emailsFavsCollapsed = createSelector(
	accesoState,
	state => state.emailsFavsCollapsed
)

export const accesoBasesConocimientoCollapsed = createSelector(
	accesoState,
	state => state.basesConocimientoCollapsed
)

export const accesoReportesCollapsed = createSelector(
	accesoState,
	state => state.reportesCollapsed
)
